import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-appearance-trash-bin',
    templateUrl: './trash-bin.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./trash-bin.component.scss'],
    standalone: false,
})
export class FiAppearanceTrashBinComponent {}
